import React, { use } from 'react'
//import {Link} from 'react-router-dom';
import Hdr from '../shared/Hdr'
import swal from 'sweetalert';
import { useState, useEffect, useRef  } from 'react';
import { apiPath1, imagePath } from "../services/apiConfig";
import TopBanner from '../components/TopBanner';
import { motion, AnimatePresence } from "framer-motion";

import ExcelExport from '../components/ExcelExport';

//import { pdfjs } from 'react-pdf';
//import PdfComp from './PdfComp';

//import { Viewer } from '@react-pdf-viewer/core';
//import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
//import '@react-pdf-viewer/core/lib/styles/index.css';
//import '@react-pdf-viewer/default-layout/lib/styles/index.css';
//import { Worker } from '@react-pdf-viewer/core';

//import pdfFile from './1.pdf'

/*
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();
*/

//import { PDFViewer } from '@react-pdf/renderer';
//import MyDocument from './components/pdf';


function Inventory() {

//  const [defaultPdfFile] = useState(pdfFile)

  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const user_id = localStorage.getItem('user-id');
  const usrName = localStorage.getItem('userName');
  const sid = localStorage.getItem('store-id');

  const [categoryData, setCategoryData] = useState([])
  const [storedata, setStores] = useState([])
  const [storeId, setStoreId] = useState('0')
  const [storeName, setStoreName] = useState('')
  const [tools, setTools] = useState([])
  const [toolId, setToolId] = useState()
  const [qty, setQty] = useState()
  const [cpu, setCPU] = useState()
  const [inventoryDataStatus, setInventoryDataStatus] = useState([])
  const [inventoryData, setInventoryData] = useState([])
  const [displayOpening, setDisplayOpening] = useState(false)
  const [displayPurchase, setDisplayPurchase] = useState(false)
  const [displayEditOpening, setDisplayEditOpening] = useState(false)
  const [displayDamage, setDisplayDamage] = useState(false)
  const [displayCertificate, setDisplayCertificate] = useState(false)
  const [displayCalibration, setDisplayCalibration] = useState(false)
  const [categoryId, setCategoryId] = useState()
  const [selectedUom, setSelectedUom] = useState()

  const [toolName, setToolName] = useState('')
  const [toolCode, setToolCode] = useState('')
  const [idDamaged, setIdDamaged] = useState()
  const [storeid, setStoreid] = useState('0')
  const [toolType, setToolType] = useState(true)
  const [toolQty, setToolQty] = useState()
  const [damagedQty, setDamagedQty] = useState()

  const [selectCategoryValue, setSelectCategoryValue] = useState('0')
  const [selectedToolValue, setSelectedToolValue] = useState('0')
  const [selectedQtyValue, setSelectedQtyValue] = useState('')
  const [selecteCPUValue, setSelecteCPUValue] = useState('')
  const [selecteReference, setSelectedReference] = useState('')
  const [selectedDamagedQty, setSelectedDamagedQty] = useState('')

  const [storeLinkedToUser,setStoreLinkedToUser] = useState([])
  const [searchNameString, setSearchNameString] = useState('')

  const [displayIssueReceipt,setDisplayIssueReceipt] = useState(false)
  const [selectedValue, setSelectedValue] = useState('Issue');
  
  const [repairShops, setRepairShops] = useState([])
  const [selectedRepairShop, setSelectedRepairShop] = useState('0')
  const [trRef, setTrRef] = useState("0")

  const [file,setFile] = useState();
  const [trType, setTrType] = useState('I')
  const ref = useRef();
  const [currentDate, setCurrentDate] = useState()
 
  
 // const defaultLayoutPluginInstance = defaultLayoutPlugin();


  const reset = () => {
    ref.current.value = "";
 //   setSpin(false)
  };

  useEffect(() => {
  //  alert(sid)
    if(sid === '0'){
      getInventory2("", 0)
    }
    else{
      getInventory2("", sid)
    }
    getToolCategory()
   // getStores()
    getStoreLinkedToUser()
    getRepairShops()
   
  }, [])

  const containerVariants = {
    hidden: { x: "100vw" }, // Start off-screen to the right
    visible: { x: 0 },   // Slide into view
    exit: { x: "100vw" },  // Slide off-screen to the right when exiting
  };

  const transitionSettings = {
    duration: 0.5,
    type: "tween",
    ease: "easeInOut",
  };

  function storeHandler(e) {

    e.preventDefault()
    setStoreId(e.target.value)
    setSearchNameString('')

    if (e.target.value === '-1'){
      return
    }

    if (e.target.value === '0') {
      getInventory2(type, 0)
    } else {

     // alert(type+', '+e.target.value)
      const selectedOption = e.target.options[e.target.selectedIndex];
      const selectedText = selectedOption.text;

      setStoreName(selectedText)

      // getInventoryByStoreId(e.target.value)
      getInventory2(type, e.target.value)

    }
  }

  /* LIST OF ALL INVENTORY */
  /*
      async function getInventory(){
      
          let result = await fetch(apiPath1+"Inventories",
          {
              method:'GET',
              headers: {"Content-Type":"application/json",
                      "Accept":"application/json",
                      "Authorization": `Bearer ${token}`
                      },
          });
          result = await result.json( );
          
          setInventoryDataStatus(result.status)
          if (result.status === true)
              {setInventoryData(result.data)}
          else
              {setInventoryData([])}
          }
*/
  /* LIST OF ALL INVENTORY */

  async function getInventory2(type, store) {

    //    alert('Inventory2 - type : '+type+', Store: '+store)      

    let result = await fetch(apiPath1 + "InventoryByToolTypeAndStore",
      {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "toolType": type,
          "storeId": store
        })
      });
    result = await result.json();

    setInventoryDataStatus(result.status)
    if (result.status === true) { setInventoryData(result.data) }
    else { setInventoryData([]) }
  }

  /* LIST OF ALL INVENTORY */
  /*    
  async function getInventoryByStoreId(id){
          
      let result = await fetch(apiPath1+"InventoryByStore/"+id,
      {
          method:'GET',
          headers: {"Content-Type":"application/json",
                  "Accept":"application/json",
                  "Authorization": `Bearer ${token}`
                  },
      });
      result = await result.json( );
  
  
      setInventoryDataStatus(result.status)
      if (result.status === true)
          {setInventoryData(result.data)}
      else
          {setInventoryData([])}
      }
  */
  /* LIST OF ALL TOOL CATAGORY List */

  async function getToolCategory() {

    let result = await fetch(apiPath1 + "ToolCategories",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setCategoryData(result.data) }
    else { setCategoryData([]) }
  }

  /* LIST OF ALL STORES */
  async function getStores() {

    let result = await fetch(apiPath1 + "Stores",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setStores(result.data) }
    else { setStores([]) }
  }

    /* LIST OF ALL STORES LINKED TO USER*/
    async function getStoreLinkedToUser() {

      let result = await fetch(apiPath1 + "StoreLinkedToUser",
        {
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
          },
        });
      result = await result.json();
 
      if (result.status === true) { setStoreLinkedToUser(result.data) 
      }
      else { setStoreLinkedToUser([]) }
    }
    
  /* LIST OF ALL TOOLS CATAGORYWISE */
  async function getTools(id) {

    let result = await fetch(apiPath1 + "ToolCategoryWise/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setTools(result.data) }
    else { setTools([]) }
  }

  function openTransactionOpening() {

    if (storeId === '0' || storeId === '-1' ) {

      swal({
        title: "No Access!",
        text: "Please Select a Store",
        icon: "info",
        button: "OK!",
      });
      return
    }

    openOpeningInventory('block')
  }

  function openTransactionPurchase() {

    if (storeId === '0' || storeId === '-1' ) {

      swal({
        title: "No Access!",
        text: "Please Select a Store",
        icon: "info",
        button: "OK!",
      });
      return
    }


    openPurchaseInventory('block')
  }


  function openOpeningInventory() {
    setDisplayOpening(true)
  }

  function openPurchaseInventory() {
    setDisplayPurchase(true)
  }

  function openEditOpeningInventory() {
    setDisplayEditOpening(true)
  }

  function openDamage() {
    setDisplayDamage(true)
  }

  function openIssueReceipt(){
    setDisplayIssueReceipt(true)
  }

  
  function openCalibration(){
    setDisplayCalibration(true)
  }

  function closeCalibration(){
    clearTransaction()
    setDisplayCalibration(false)
  }

  function openCertificate(){
    setDisplayCertificate(true)
  }

  function closeCertificate(){
    //clearTransaction()
    setDisplayCertificate(false)
  }

  function closeIssueReceipt(){
    clearTransaction()
    setDisplayIssueReceipt(false)
  }

  function closeDamage() {
    clearTransaction()
    setDisplayDamage(false)
  }

  function closeOpeningInventory() {
    clearTransaction()
    setDisplayOpening(false)
  }

  function closePurchaseInventory() {
    clearTransaction()
    setDisplayPurchase(false)
  }

  function closeEditOpeningInventory() {
    clearTransaction()
    setDisplayEditOpening(false)
  }

  function categoryHandler(e) {

    e.preventDefault()
    setSelectCategoryValue(e.target.value)
    setCategoryId(e.target.value)
    getTools(e.target.value)
  }

  function toolHandler(e) {
    e.preventDefault()
    setSelectedToolValue(e.target.value)
    setToolId(e.target.value)
   
    getToolDetail(e.target.value)
  }

  function qtyHandler(e) {
    e.preventDefault()
    setSelectedQtyValue(e.target.value)
    setQty(e.target.value)
  }

  function updQtyHandler(e){
    e.preventDefault()
    setUpdToolQty(e.target.value)
  }

  function cpuHandler(e) {
    e.preventDefault()
    setSelecteCPUValue(e.target.value)
    setCPU(e.target.value)
  }

  
  function referenceHandler(e) {
    e.preventDefault()
    setSelectedReference(e.target.value)
    //setReference(e.target.value)
  }  

  function updCPUHandler(e){
    e.preventDefault()
    setUpdToolCost(e.target.value)
  }

  function setNameString(e){
    e.preventDefault()
    setSearchNameString(e.target.value)
  }

  async function addOpening() {

    // alert(storeId+', '+toolId+', '+qty+', '+selectedUom+', '+cpu)

    if (cpu === null) {
      cpu = 0;
    }

    let result = await fetch(apiPath1 + "InventoryAddOpening", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "store_id": storeId,
        "tool_id": toolId,
        "quantity": qty,
        "uom": selectedUom,
        "cpu": cpu

      })
    });
    result = await result.json();

    showSwal(result.status, result.msg)

    closeOpeningInventory()

    //      getInventoryByStoreId()
    getInventory2("", storeId)

  }

  async function getToolDetail(id) {

    let result = await fetch(apiPath1 + "Tool/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json()

    setSelectedUom(result.data.uom)

  }

  function DamagedItem(id, name, code, storeID, type, qty) {

    //alert(qty)
    setIdDamaged(id)
    setToolName(name)
    setToolCode(code)
    setStoreid(storeID)
    setToolQty(qty)
    setDamagedQty(1)
    if (type === 'Heavy Tool') { setToolType(true) }
    else { setToolType(false) }

    openDamage()

  }




  const [idIssueReceipt,setIdIssueReceipt] = useState()
  const [issueReceiptQty,setIssueReceiptQty] = useState(1)

  function IssueReceipt(id, name, code, storeID, type, qty) {

    //alert(qty)
    setIdIssueReceipt(id)
    setToolName(name)
    setToolCode(code)
    setStoreid(storeID)
    setToolQty(qty)
    setIssueReceiptQty(1)

    if (type === 'Heavy Tool') { setToolType(true) }
    else { setToolType(false) }

    openIssueReceipt()

  }

 // function dummy() { }

  async function updateDamageMark() {

   //  alert(storeid+', '+idDamaged+', '+damagedQty)

    let result = await fetch(apiPath1 + "MarkToolAsDamaged",
      {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "store_id": storeid,
          "tool_id": idDamaged,
          "quantity": damagedQty
        })
      });
    result = await result.json();

    showSwal(result.status, result.msg)

    closeDamage()

  //  getInventory2("", 0)
    if(sid === '0'){
      getInventory2("", 0)
    }
    else{
      getInventory2("", sid)
    }

  }

  

  async function updateIssueReceipt() {

   // alert(storeid+', '+idIssueReceipt+', '+useQty+', '+trType)
 
     let result = await fetch(apiPath1 + "IssueToolsInUse",
       {
         method: 'POST',
         headers: {
           "Content-Type": "application/json",
           "Accept": "application/json",
           "Authorization": `Bearer ${token}`
         },
         body: JSON.stringify({
           "transaction_type" : trType,
           "store_id": storeid,
           "tool_id": idIssueReceipt,
           "qty_on_site": useQty
         })
       });
     result = await result.json();
 
     showSwal(result.status, result.msg)
 
     closeIssueReceipt()
     clearTransaction()
 
   //  getInventory2("", 0)
     if(sid === '0'){
       getInventory2("", 0)
     }
     else{
       getInventory2("", sid)
     }
 
   }

  function updateCalibration() {
   // alert(storeid+', '+calibrationId+', '+trType +', '+currentDate+', '+orderNo+', '+selectedRepairShop )

    if (trType === 'C'){
      sendForCalibration()
    }
    else{
      recdFromCalibration()
    }

   }


   async function recdFromCalibration(){

    // alert(storeid+', '+calibrationId+', '+trType +', '+currentDate+', '+parseInt(trRef)+', '+trRefDoc+', '+uom+', '+ref.current.value+', '+certDt+', '+expDt)

    //return

    if (ref.current.value === ""){
      swal("No Image File !")
      return
    }

    const formData=new FormData();

    formData.append('calcert',file);
    formData.append('transaction_date', currentDate);
    formData.append('store_id', storeid);
    formData.append('tool_id', calibrationId);
    formData.append('ref_doc_id', parseInt(trRef));
    formData.append('ref_doc_number', trRefDoc);
    formData.append('issued_date', certDt);
    formData.append('uom', uom);
    formData.append('expiry_date', expDt);
  
   let result = await fetch(apiPath1 + "ToolCalibrationReceipt",

      {
        method: 'POST',
        headers: {
         // "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body:formData
      });


    // Check if the response was successful (e.g., status 200-299)

    result = await result.json();

 //   console.log('result :', result)

   showSwal(result.status, result.msg)

    closeCalibration()
    clearTransaction()

    if(sid === '0'){
      getInventory2("", 0)
    }
    else{
      getInventory2("", sid)
    }

   }

  async function sendForCalibration() {

  
      let result = await fetch(apiPath1 + "ToolCalibrationIssue",
        {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify({
            "transaction_date" : currentDate,
            "store_id": storeid,
            "tool_id": calibrationId,
            "repair_shop_id": selectedRepairShop,
            "ref_doc_no": orderNo
          })
        });
      result = await result.json();

      console.log(result)
  
      showSwal(result.status, result.msg)
  
      closeCalibration()
      clearTransaction()
  
      if(sid === '0'){
        getInventory2("", 0)
      }
      else{
        getInventory2("", sid)
      }
  
    }

 
  function clearTransaction() {
    setSelectCategoryValue('0')
    setSelectedToolValue('0')
    setSelecteCPUValue('')
    setSelectedReference('')
    setSelectedDamagedQty('')
    setSelectedQtyValue('')
  //  setIssueReceiptQty('')
  //  setSelectedUseQty('')
    setIsDisabled(true)
    setUseQty()
  //  setSelectedUseQty(1)
  }


  function HandleToolQuantityChange(e) {

    //let DamageQty = e.target.value

    if (toolType === true) { setDamagedQty(1) }
    else {

      if (e.target.value > toolQty || e.target.value < 0) {
        swal({
          title: "Fail!",
          text: "Damaged Quantity cannot Zero or more than Actual Quantity",
          icon: "error",
          button: "OK!",
        });

      }
      else {
        setSelectedDamagedQty(e.target.value)
        setDamagedQty(e.target.value)
      }

    }
  }
  
  const [useQty, setUseQty] = useState(0)
 // const [selectedUseQty,setSelectedUseQty] = useState(1)
  //const [selectedType, SetSelectedType] = useState('0')
  const [type, setType] = useState('')

  function HandleUseQuantityChange(e) {

    //alert(trType)

    if (toolType === true) { setUseQty(1) } // Tool type : Heavy Tools
    else {

      if (trType === 'I'){
        if (e.target.value > toolQty || e.target.value < 0) {
          swal({
            title: "Fail!",
            text: "Issue Quantity cannot Zero or more than Actual Quantity",
            icon: "error",
            button: "OK!",
          });
        }
        else {
        //  setSelectedUseQty(e.target.value)
          setUseQty(e.target.value)
        }
      }else{
        //  setSelectedUseQty(e.target.value)
          setUseQty(e.target.value)
      }
    }
  }


  function typeHandler(e) {

    e.preventDefault()
    setType(e.target.value)
    setSearchNameString('')

    if (e.target.value === '') {
      getInventory2(e.target.value, "0")
    } else {

      const selectedOption = e.target.options[e.target.selectedIndex];
      const selectedText = selectedOption.text;

      // setStoreName(selectedText)
      setType(e.target.value)

      getInventory2(e.target.value, storeId)

    }
  }

  function collectInventory(nameString){

    //alert('Collect Inventory '+nameString)
    
    getInventory3(type,storeId,nameString)
  }

  async function getInventory3(type, store, nameString) {

    //alert('hello')

    //alert('Inventory3 - type : '+type+', Store: '+store+', Name: '+ nameString)    

    //return

    let result = await fetch(apiPath1 + "InventoryByToolTypeStoreAndDescSearchString",
      {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "toolType": type,
          "storeId": store,
          "searchStr" : nameString
        })
      });
    result = await result.json();

    setInventoryDataStatus(result.status)
    if (result.status === true) { setInventoryData(result.data) }
    else { setInventoryData([]) }
  }




  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success !",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  const [buttonText, setButtonText] = useState('Issue to floor')
  const [buttonTxt, setButtonTxt] = useState('Issue-Calibration')
  const [isDisabled, setIsDisabled] = useState(true)

  function trTypeHandler(e){
    if (e.target.value === '0'){
      swal({
        title: "No Action!",
        text: "Please Select a Transaction Type",
        icon: "info",
        button: "OK!",
      });
      setIsDisabled(true)
      return

    }else{
      if (e.target.value === 'R'){
        setButtonText('Recd from Floor')
      }else{
        setButtonText('Issue to Floor')
      }
      setTrType(e.target.value)
      setIsDisabled(false)

    }

    setUseQty(0)
  }

  function trCalibrationTypeHandler(e){

    //alert(storeid)
  
    if (e.target.value === '0'){
      swal({
        title: "No Action!",
        text: "Please Select a Transaction Type",
        icon: "info",
        button: "OK!",
      });
      setIsDisabled(true)
      return

    }else{
      if (e.target.value === 'C'){
        setButtonTxt('Send-Calibration')
      }else{
        setButtonTxt('Receive-Calibration')
      }
      setTrType(e.target.value)
      setIsDisabled(false)
    }
    
    getPendingCalibratedItems(storeid)

  }


    const getFormattedDate = () => {
      const today = new Date();
      const year = today.getFullYear();
      // getMonth() returns a 0-indexed month, so add 1
      const month = (today.getMonth() + 1).toString().padStart(2, '0'); 
      const day = today.getDate().toString().padStart(2, '0');
  
      return `${year}-${month}-${day}`;
    };

const [calibrationId, setCalibrationId] = useState()
const [orderNo, setOrderNo] = useState()
const [uom,setUOM] = useState()
const [status, setStatus] = useState()

  function calibration(id, name, code, storeID, type, qty, uom, status) {

   // alert(getFormattedDate())
    setCurrentDate(getFormattedDate())
    setCalibrationId(id)
    setToolName(name)
    setToolCode(code)
    setStoreid(storeID)
    setToolQty(qty)
    setUOM(uom)
    setStatus(status)

    if (status === 'Ok' || status === 'Calibration Out'){

    }else{
      swal({
        title: "No Access!",
        text: "Please Selecte ok status for Calibration",
        icon: "info",
        button: "OK!",
      })
      return
    }

    //setIssueReceiptQty(1)

    if (type === 'Heavy Tool') { setToolType(true) }
    else { setToolType(false) }

    openCalibration()
   
  }

  function upload(e){
  //  alert('upload')
   // alert(e.target.file[0])
    setFile(e.target.files[0]);
 }

  /* LIST OF ALL SITE WAREHOUSE STORE */
  async function getRepairShops() {

    let result = await fetch(apiPath1 + "RepairShops",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setRepairShops(result.data) }
    else { setRepairShops([]) }
  }

  function storeHandlerRepairShop(e) {
    e.preventDefault()
    setSelectedRepairShop(e.target.value)
    setTrRef(e.target.value)
  }

  function HandleOrderNo(e){
    setOrderNo(e.target.value)
  }

  const [pendingCalibratedItems,setPendingCalibratedItems] = useState([])
  const [pendingItemStatus,setPendingItemStatus] = useState()

    async function getPendingCalibratedItems(id) {

     // alert(id)
  
      let result = await fetch(apiPath1 + "ToolTransactionByTypeStoreStatusDate",
        {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify({
            "store_id": id,
            "transaction_type": 'C',
            "status": "Callibration Out",
            "date_from":'',
            "date_to":''
          })
        });
      result = await result.json();
  
      setPendingItemStatus(result.status)

     // alert('Status: '+result.status)
  
      if (result.status === true) {
        setPendingCalibratedItems(result.data)
      } else {
        setPendingCalibratedItems([])
      }
  
    }

    const [trRefDoc,setTrRefDoc] = useState()

    function refHandlerCalibratedItem (e){
   //   alert(e.target.value)

      const selectedOption = e.target.options[e.target.selectedIndex];
      const selectedText = selectedOption.text;
  
      setTrRefDoc(selectedText)
  
      e.preventDefault()
     // setSelecteRepairdItem(e.target.value)
      setTrRef(e.target.value)


    }

    const [certDt,setCertDt] = useState('')
    const [expDt,setExpDt] = useState('')

    function HandleCertDt(e){
      e.preventDefault()
      setCertDt(e.target.value)
    }

    function HandleExpDt(e){
      e.preventDefault()
      setExpDt(e.target.value)
    }

    const handleClick = () => {
      findCertificate()
      openCertificate()
    };

const [certDetails, setCertDetails] = useState([])
const [certStatus, setCertStatus]= useState()


    async function findCertificate(){

   
      let result = await fetch(apiPath1 + "ToolCallibrationCertificate/"+ calibrationId,
        {
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
          },
        });
      result = await result.json();
   
      setCertStatus(result.status)
      if (result.status === true) { setCertDetails(result.data) }
      else { setCertDetails([]) }

    }

   
//const pdf_file_url = 'https://localhost:3000/2.pdf'
const pdf_file_url = 'https://toolease-api.ebistesthub.in/storage/certificates/b2mCNjXEvAQ164jnbUdRYBDlhBVzmHuUz7Ad2ZfI.pdf'

const handleDownload = (url) => {
 // alert(url);

  fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.blob();
    })
    .then(blob => {
      const blobURL = window.URL.createObjectURL(new Blob([blob]));
      const fileName = url.split('/').pop();
      const aTag = document.createElement('a');
      aTag.href = blobURL;
      aTag.setAttribute('download', fileName);
      document.body.appendChild(aTag);
      aTag.click();
      aTag.remove();
    })
    .catch(error => {
      console.error('Download failed:', error);
      //alert('Download failed, check the console for details');
    });
}

//const [updToolName, setUpdToolName] = useState()
const [updToolDesc, setUpdToolDesc] = useState()
const [updToolQty, setUpdToolQty] = useState()
const [updToolUOM, setUpdToolUOM] = useState()
const [updToolCost, setUpdToolCost] = useState()
const [updTrId, setUpdTrId] = useState()
const [updToolId,setUpdToolId] = useState()
const [updStoreId,setUpdStoreId] = useState()
const [updQtyPrev,setUpdQtyPrev] = useState()
const [updCPUPrev,setUpdCPUPrev] = useState()

const [storenm, setStorenm] = useState()

async function getOpening(toolId,storeId, storeNm){

  let result = await fetch(apiPath1 + "OpeningInventoryForItemInStore",
    {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "store_id": storeId,
        "tool_id": toolId
      })
    });

  result = await result.json();

  if (result.status === true) {

    setUpdTrId(result.data[0].transaction_id);
    setUpdToolId(toolId);
    setUpdStoreId(storeId);
    setUpdQtyPrev(result.data[0].quantity);
    setUpdCPUPrev(result.data[0].cpu);

   // setUpdToolName(result.data[0].tool_name);
    setUpdToolDesc(result.data[0].tool_description);
    setUpdToolQty(result.data[0].quantity);
    setUpdToolUOM(result.data[0].uom);
    setUpdToolCost(result.data[0].cpu);

    setStorenm(storeNm)

    openEditOpeningInventory('block')

    }
    else{ 
      swal({
        title: "No Opening!",
        text: "No opening in this Tool Code",
        icon: "info",
        button: "OK!",
    });
   // setOpeningData([])
  }
 
 // setOpeningData(result.data) 

}

async function updOpening(){

  // alert(updTrId+', '+updToolId+', '+updStoreId+', '+updQtyPrev+', '+updToolQty+', '+updCPUPrev+', '+updToolCost)


    let result = await fetch(apiPath1 + "InventoryUpdate", {
        method: 'PATCH',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "transaction_id": updTrId,
          "tool_id": updToolId,
          "store_id": updStoreId,
          "qtyPrev": updQtyPrev,
          "qtyNew": updToolQty,
          "cpuPrev": updCPUPrev,
          "cpuNew": updToolCost
        })
      });
  
      result = await result.json();
  
      showSwal(result.status, result.msg)
  
      closeEditOpeningInventory();
      getInventory2("", 0)

}

/*
async function handleDownload (pdf_file_url)  {



try {
  const response = await fetch(pdf_file_url);
  const blob = await response.blob();

  const url = window.URL.createObjectURL(blob) ;

  const fileName = url.split('/').pop()

  alert(fileName)
  
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName || 'downloaded.pdf'

  document.body.appendChild(link);
  link.click() ;

  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);

}catch(error){
  console.error('Error downloading PDF',error);
}

}
*/



  return (

    <div style={{ 'width': '100%', 'height': '100vh' }}>
      <Hdr />
      <TopBanner name={'Inventory Detail'} />

      <div className="row p16 " style={{ 'height': '98%' }}>
        <div className=" c12-l-12 cont__content-parent p4" style={{ 'height': '100%'}}>
          {/* CTA SECTION */}
          <div className="row mb16">
            <div className="c12-l-4 box corner-round">
              <div className='row'>
                <div className="c12-g-l-5" >
                  <p className='txt-darkblue mb2' style={{ 'marginLeft': '4px' }}>Select Tool Type</p>
                  <select className="small" onChange={typeHandler}>
                    <option value="">All Tools</option>
                    <option value="Tool">Tool</option>
                    <option value="Heavy Tool">Heavy Tool</option>
                    <option value="Consumable">Consumable</option>
                  </select>
                </div>

                <div className="c12-g-l-7">
                  <p className='txt-darkblue mb2' style={{ 'marginLeft': '4px' }}>Select Store</p>
                  <select className="small" onChange={storeHandler} style={{ "width": '98%' }}>
                  {(sid === '0' ?
                    <option value="0" >All Stores</option> 
                    : <option value="-1" >Select Store</option> 
                  )}
                    {
                      storeLinkedToUser.map((item, index) =>
                        <option key={item.id} value={item.id}>{item.store_name}</option>
                      )
                    }
                  </select>
                </div>

              </div>
            </div>
            
            <div className="c12-g-l-4 box corner-round">
           
              <div className='row'>
                <div className="c12-l-11">
                  <p className='txt-darkblue mb2' style={{ 'marginLeft': '4px' }}>Select Tool Description</p>

                  <input type="text" className="box small" style={{ 'marginLeft': '4px', "width": '97%' }}
                  value = {searchNameString} 
                  placeholder="Tools Description" onChange={setNameString}  />
                </div>
                <div className="c12-l-1" >
                  <button onClick={(e) => {collectInventory(searchNameString)}} 
                  className="center" style={{'marginTop':'24px', 'marginRight':'4px'}}><img src={require('../asset/icons/adm_search.png')} alt="" /></button>
                </div>
              </div>
            </div>
           
            <div className="c12-l-4">
              <div className=" c12-l-12">
                <div className="row p4">
                  <div className="c12-l-1" style={{'marginTop': '18px'}}>
                    <ExcelExport data={inventoryData} fileName="Inventory" />  
                  </div>

                  <div className="c12-l-11" style={{'horizontalAlign': 'right'}} > 
                    <div className=" c12-l-12">
                      <div className="row p16">
                        <div className="c12-l-6">
                          <button onClick={openTransactionOpening} type="button" name="button" style={{'fontSize':'10px'}}
                            className="btn gradient round">Add Opening </button> 
                        </div>
                        <div className=" c12-l-6">
                          <button onClick={openTransactionPurchase} type="button" name="button" style={{'fontSize':'10px'}}
                          className="btn gradient round">Add Purchase</button> 
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          {/* DATA TABLE SECTION */}
          <div className="c12-l-12 cont__content p4" style={{ 'height': '83%' }}>
            <table style={{ 'display': 'block' }}>
              <thead className='thead-blue'>
                <tr>
                {/*  <th className="th-border" width="5%">Id</th>  */}
                  <th className="th-border left" width="20%">Store Name</th>
                  <th className="th-border left" width="20%">Category Name</th>
                  <th className="th-border left" width="5%">Tool Code</th>
                  <th className="th-border left" width="5%">Tool Tag</th>
                  <th className="th-border left" width="20%">Tool Name</th>
                  <th className="th-border left" width="30%" style={{'verticalAlign':'top','fontSize':'10px'}}>Tool Description</th>
                  <th className="th-border left" width="15%">Type</th>
                  <th className="th-border right" width="8%">Quantity</th>
                  <th className="th-border right" width="5%">Quantity in use</th>
                  <th className="th-border left" width="5%">UOM</th>
                  <th className="th-border left" width="7%">Edit Opening</th>
                  <th className="th-border left" width="8%">Site Issue/ Receipt</th>
                  <th className="th-border Center" width="7%">Mark Damaged</th>
                  <th className="th-border Center" width="7%">calibration</th>
                  <th className="th-border Center" width="7%">status</th>
                </tr>
              </thead>
              <tbody >
                {
                  (inventoryDataStatus === true ?
                    (
                      inventoryData.map((item, index) =>
                        <tr className="tr-two-color-grey" key={index}>
                     {/*  <td className="center">{item.id}</td>   */}
                          <td className="" >{item.store_name}</td>
                          <td className="" >{item.category_name}</td>
                          <td className="" hidden>{item.tool_id}</td>
                          <td className="" >{item.tool_code}</td>
                          <td className="" >{item.tool_tag}</td>
                          <td className="" >{item.tool_name}</td>
                          <td className="" style={{'verticalAlign':'top','fontSize':'10px'}}>{item.tool_description}</td>
                          <td className="" >{item.tool_type}</td>
                          <td className="right" >{item.quantity}</td>
                          <td className="right" >{item.qty_in_use}</td>
                          <td className="" >{item.uom}</td>
                          <td onClick={(e) => { getOpening(item.tool_id, item.store_id, item.store_name) }} className="center" ><img src={require('../asset/icons/adm_edit.png')} alt="" /></td>
                          <td onClick={(e) => { IssueReceipt(item.tool_id, item.tool_name, item.tool_code, item.store_id, item.tool_type, item.quantity, e.target.value) }} className="center"><img src={require('../asset/icons/icon-issue-rcpt.png')} alt="" /></td>
                          <td onClick={(e) => { DamagedItem(item.tool_id, item.tool_name, item.tool_code, item.store_id, item.tool_type, item.quantity, e.target.value) }} className="center"><img src={require('../asset/icons/icon-mark-damaged.png')} alt="" /></td>
                          {
                            (item.require_calibration === 1 ?
                              <td onClick={(e) => { calibration(item.tool_id, item.tool_name, item.tool_code, item.store_id, item.tool_type, item.quantity, item.uom, item.status,e.target.value) }} className="center"><img src={require('../asset/icons/calibration.png')} alt="" /></td>
                             :<td></td> )
                          }
                          <td className="" style={{'verticalAlign':'top','fontSize':'10px'}}>{item.status}</td>
                          {/*  <td className="" >{item.store_id}</td>  */}
                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table> 
          </div>


        {/* ADD OPENING INVENTORY */}
        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayOpening && (
          <motion.div
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="OpeningInventory" className="cont__lineitem">

            <form className="" action="" method="">
              <div className="row box grey corner-round-tr">
                <div className="c12-l-8">
                  <h6 className='txt-subtlewhite pt8'>Opening Inventroy</h6>
                </div>
                <div className="c12-l-3"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeOpeningInventory}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px32">

                <div className="c12-l-12">

                  <p hidden>{storeId} </p><br />

                  <h3>Store Name : {storeName} </h3><br />

                  <p style={{ 'marginTop': '5px' }}>Select Categoty</p>
                  <select className="small" value={selectCategoryValue} onChange={categoryHandler} style={{ "width": '98%', 'marginTop': '1px' }} >
                    <option value="0" >Select Catagory</option>
                    {
                      categoryData.map((item, index) =>
                        <option key={item.id} value={item.id}>{item.category_name}</option>
                      )
                    }
                  </select>

                  <p style={{ 'marginTop': '5px' }}>Select Tools</p>
                  <select className="small" value={selectedToolValue} onChange={toolHandler} style={{ "width": '98%', 'marginTop': '1px' }} >
                    <option value="0" >Select Tools</option>
                    {
                      tools.map((item, index) =>
                        <option key={item.id} value={item.id}>{item.tool_description}</option>
                      )
                    }
                  </select>

                  <p style={{ 'marginTop': '5px' }}>Quantity</p>
                  <input type="number" value={selectedQtyValue} className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                    placeholder="Quantity" onChange={qtyHandler} />

                  <p style={{ 'marginTop': '5px' }}>Cost per Unit</p>
                  <input type="number" value={selecteCPUValue} className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                    placeholder="Cost per Unit" onChange={cpuHandler} /> <br />

                  <button className="btn gradient round large" type="button" onClick={addOpening}>Save Opening</button>

                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>

        {/* ADD PURCHASE INVENTORY */}
        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayPurchase && (
          <motion.div
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="PurchaseInventory" className="cont__lineitem">

            <form className="" action="" method="">
              <div className="row box blue corner-round-tr">
                <div className="c12-l-8">
                  <h6 className='txt-subtlewhite pt8'>Purchase Inventroy</h6>
                </div>
                <div className="c12-l-3"></div>
                <div className="c12-l-1 center">
                  <p onClick={closePurchaseInventory}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px32">

                <div className="c12-l-12">

                  <p hidden>{storeId} </p><br />

                  <h3>Store Name : {storeName} </h3><br />

                  <p style={{ 'marginTop': '5px' }}>Select Categoty</p>
                  <select className="small" value={selectCategoryValue} onChange={categoryHandler} style={{ "width": '98%', 'marginTop': '1px' }} >
                    <option value="0" >Select Catagory</option>
                    {
                      categoryData.map((item, index) =>
                        <option key={item.id} value={item.id}>{item.category_name}</option>
                      )
                    }
                  </select>

                  <p style={{ 'marginTop': '5px' }}>Select Tools</p>
                  <select className="small" value={selectedToolValue} onChange={toolHandler} style={{ "width": '98%', 'marginTop': '1px' }} >
                    <option value="0" >Select Tools</option>
                    {
                      tools.map((item, index) =>
                        <option key={item.id} value={item.id}>{item.tool_description}</option>
                      )
                    }
                  </select>

                  <p style={{ 'marginTop': '5px' }}>Quantity</p>
                  <input type="number" value={selectedQtyValue} className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                    placeholder="Quantity" onChange={qtyHandler} />

                  <p style={{ 'marginTop': '5px' }}>Cost per Unit</p>
                  <input type="number" value={selecteCPUValue} className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                    placeholder="Cost per Unit" onChange={cpuHandler} />

                  <p style={{ 'marginTop': '5px' }}>Purchase Reference</p>
                  <textarea type="text" value={selecteReference} className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                    placeholder="Purchase Reference (if any)" onChange={referenceHandler} /> <br />

                  <button className="btn gradient round large" type="button" onClick={addOpening}>Save Purchase</button>

                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>



        {/* EDIT OPENING INVENTORY */}
        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayEditOpening && (
          <motion.div
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="OpeningInventory" className="cont__lineitem">

            <form className="" action="" method="">
              <div className="row box grey corner-round-tr">
                <div className="c12-l-8">
                  <h6 className='txt-subtlewhite pt8'>Edit Opening Inventroy</h6>
                </div>
                <div className="c12-l-3"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeEditOpeningInventory}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px32">

                <div className="c12-l-12">

                  <p hidden>{storeId} </p><br />

                  <h6>Store Name : {storenm} </h6><br />

                  <h6>Tool Description : </h6>
                  <p> {updToolDesc} </p><br /><br />

                  <p style={{ 'marginTop': '5px' }}>Quantity</p>
                  <input type="number" value={updToolQty} className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                    placeholder="Quantity" onChange={updQtyHandler} />
                  <p style={{ 'marginTop': '5px' }}>Cost per Unit</p>
                  <input type="number" value={updToolCost} className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                    placeholder="Cost per Unit" onChange={updCPUHandler} /> <br />

                  <button className="btn gradient round large" type="button" onClick={updOpening}>Save Opening</button>

                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>

        {/* SCREEN FROM ADD DAMAGE TOOLS */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayDamage && (
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="toolDamage" className="cont__lineitem">
            <form className="" action="" method="">
              <div className="row box grey corner-round-tr">
                <div className="c12-l-8">
                  <h6 className='txt-subtlewhite pt8'>Mark Damage Items</h6>
                </div>
                <div className="c12-l-3"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeDamage}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px16">
                <div className="c12-l-12">

                  <br />
                  <h4 style={{ 'marginTop': '5px' }}>Tool Code : {toolCode}</h4><br /><br />
                  <h3 style={{ 'marginTop': '5px' }}>{toolName}</h3><br /><br />

                  {
                    (toolType === false ?
                      (
                        <div>
                          <p style={{ 'marginTop': '5px' }}>Quantity</p>
                          <input type="number" value={selectedDamagedQty} className="box small" style={{ 'textAlign': 'right' }}
                            placeholder="Quantity" onChange={HandleToolQuantityChange} />
                        </div>
                      )
                      : <div></div>)
                  }
                  <button className="btn gradient round large" type="button" onClick={updateDamageMark}>Mark as Damaged</button>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>

        {/* SCREEN FROM ADD ISSUE/RECEIPT TOOLS */}
        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayIssueReceipt && (
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="toolIssueReceive" className="cont__lineitem">
            <form className="" action="" method="">
              <div className="row box grey corner-round-tr">
                <div className="c12-l-9">
                  <h6 className='txt-subtlewhite pt8'>Issue - Receipt of Site Items</h6>
                </div>
                <div className="c12-l-2"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeIssueReceipt}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px16">
                <div className="c12-l-12">
                  <br />
                  <h4 style={{ 'marginTop': '5px' }}>Tool Code : {toolCode}</h4><br /><br />
                  <h3 style={{ 'marginTop': '5px' }}>{toolName}</h3><br /><br />
                </div>
                
                <div>
                  <p className='txt-darkblue mb2' style={{ 'marginLeft': '4px' }}>Select Transaction Type</p>
                  <select className="small" onChange={trTypeHandler}>
                    <option value="0">Select Transaction</option>
                    <option value="I">Issue</option>
                    <option value="R">Received</option>
                  </select>
                </div>

                <div className="row mt16">
                  <div className="c12-l-12" >   
                    {
                      (toolType === false ?
                        (
                          <div>
                            <p style={{ 'marginTop': '5px',  }}>Quantity</p>
                            <input type="number" className="box small" style={{ 'textAlign': 'right' }} value={useQty}
                              placeholder="Quantity" onChange={HandleUseQuantityChange} />
                          </div>
                        )
                        : <div></div>)
                    }
                    <br/>
                    <button className="btn gradient round large" type="button" 
                      onClick={updateIssueReceipt} disabled={isDisabled}>{buttonText}</button>
                  </div>
                </div>
              </div>
              
            </form>
          </motion.div>
          )}
        </AnimatePresence>

        {/* SCREEN FROM CALIBRATING TOOLS */}
        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayCalibration && (
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="toolCalibration" className="cont__lineitem">
            <form className="" action="" method="">
              <div className="row box grey corner-round-tr">
                <div className="c12-l-9">
                  <h6 className='txt-subtlewhite pt8'>Calibration of Tool</h6>
                </div>
                <div className="c12-l-2"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeCalibration}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px16">
                <div className="c12-l-12">
                  <br />
                  <h4 style={{ 'marginTop': '5px' }}>Tool Code : {toolCode}</h4><br />
                  <h3 style={{ 'marginTop': '5px' }}>{toolName}</h3><br />
                  <div>
                    <span className='txt-darkblue mb2' onClick={handleClick} style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                      Show Current Certificate
                    </span><br /><br />
                  </div>
                 
                </div>
                
                <div>
                <p className='txt-darkblue mb2' style={{ 'marginLeft': '4px' }}>Select Transaction Type</p>
                <select className="small" onChange={trCalibrationTypeHandler}>
                  <option value="0">Select Transaction</option>
                  {
                    (status === 'Ok' ?
                      (
                        <option value="C">Send for Calibration</option>

                      )
                      :(
                        <option value="D">Received from Calibration</option>
                      )
                    )
                  }
                </select>
                </div><br />

                <div className="c12-l-12">
                {
                  (trType === 'D' ?
                    (
                    <div className="c12-l-12">
                      <div>
                      <p className='txt-darkblue mb2' style={{ 'marginTop': '5px',  }}>Referance Documents</p>
                        <select className="small" onChange={refHandlerCalibratedItem} style={{ "width": '98%', 'marginTop': '1px' }}>
                          <option value="0" >Select Reference</option>
                          {
                            (pendingItemStatus === true ?
                              (
                                pendingCalibratedItems.map((item, index) =>
                                  <option key={item.id} value={item.id}>{item.transaction_code}</option>

                                ))
                              : <option>No Data</option>)
                          }
                        </select>
                      </div>
                      <div className="row mt4">
                        <div className="c12-g-l-6">
                          <p className='txt-darkblue mb2' style={{ 'marginTop': '5px',  }}>Certificate Date</p>
                          <input type="date" className="box small" style={{ 'textAlign': 'left' }}
                            placeholder="Cert Date" onChange={HandleCertDt} />
                        </div>
                        <div className="c12-g-l-6">
                          <p className='txt-darkblue mb2' style={{ 'marginTop': '5px',  }}>Expiry Date</p>
                          <input type="date" className="box small" style={{ 'textAlign': 'left' }}
                            placeholder="Exp Date" onChange={HandleExpDt} />
                        </div>
                      </div>
                    </div>
                    )
                    : 
                    <div>
                      <div>
                        <p className='txt-darkblue mb2' style={{ 'marginTop': '5px',  }}>Order Number</p>
                        <input type="text" className="box small" style={{ 'textAlign': 'left' }}
                          placeholder="OrderNo" onChange={HandleOrderNo} />
                      </div>
                      <div>
                        <p className='txt-darkblue mb2'>Select Repairing Shop</p>
                        <select value={selectedRepairShop} className="small" onChange={storeHandlerRepairShop} style={{ 'marginTop': '1px' }}>
                          <option value="0" >Select Store</option>
                          {
                            repairShops.map((item, index) =>
                              <option key={item.id} value={item.id}>{item.store_name}</option>
                            )
                          }
                        </select>
                     </div>
                    </div>
                  )
                }
                </div>

                <div className="row mt16">
                  <div className="c12-l-12" >   
                    {
                      (trType === 'D' ?
                        (
                          <div>
                            <p className='txt-darkblue mb2'>Insert File</p>
                            <input type="file" ref={ref} onChange= {(e)=>upload(e)} />
                          </div>
                        )
                        : <div></div>)
                    }
                    <br/>
                    <button className="btn gradient round large" type="button" 
                      onClick={updateCalibration} disabled={isDisabled}>{buttonTxt}</button>
                  </div>
                </div>
              </div>
              
            </form>
          </motion.div>
          )}
        </AnimatePresence>        



        {/* SCREEN FROM CERTIFICATE DISPLAY */}
        <AnimatePresence> {/* Wrap with AnimatePresence */}
        {displayCertificate && (
        <motion.div 
          key="sliding-container" // Crucial for AnimatePresence to work
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          exit="exit" // Specify the exit animation
          transition={transitionSettings}
          id="toolCalibration" className="cont__AddItems" style={{'height':'95%'}}>
          <form className="" action="" method="">
            <div className="row box grey corner-round-tr">
              <div className="c12-l-9">
                <h6 className='txt-subtlewhite pt8'>Calibration Certificate</h6>
              </div>
              <div className="c12-l-2"></div>
              <div className="c12-l-1 align-right">
                <p onClick={closeCertificate}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
              </div>
            </div>
            <div className="row mt8 px8">
              <div className="c12-l-12 cont__content pr4" > 
   
                    <table style={{ 'height': '450px', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
                      <thead className='thead-blue'>
                        <tr>
                          <th className="th-border" width="5%">Id</th>
                          <th className="th-border left" width="10%">Issued by</th>
                          <th className="th-border left" width="10%">Issue Dt</th>
                          <th className="th-border left" width="10%">Expiry Dt</th>
                          <th className="th-border center" width="10%">download</th>
                          <th className="th-border center" width="10%">File Name</th>
                        </tr>
                      </thead>
                      <tbody >
                        {
                          (certStatus === true ?
                            (
                              certDetails.map((item, index) =>
                                <tr className="tr-two-color-grey" key={index}>
                                  <td className="center">{item.id}</td>
                                  <td className="">{item.issued_by}</td>
                                  <td className="">{item.issued_date}</td>
                                  <td className="">{item.expiry_date}</td>
                                  <td onClick={() => {handleDownload(pdf_file_url)}} className="center"><img src={require('../asset/icons/adm_download.png')} alt="" /></td>
                                  <td className="">{item.file_path}</td>
                                </tr>
                              ))
                            : <tr><td>No data</td></tr>)
                        }
                      </tbody>
                    </table> 
                  </div>
                </div>

          </form>
          </motion.div>
          )}
        </AnimatePresence>

        </div>
      </div>
    </div>

  )

}

export default Inventory;
